// IE 2026 11 04 / ODOO-350449 (заказ Игоря: верхняя полоса в один ряд — иконки вместо подписей, «⋯» вместо поиска)
// Сжатая компоновка верхней полосы (AppTopbar.vue): когда чипсы-селекторы не помещаются в один ряд, вместо двух слоёв
// (название стола над иконкой панели, кнопки базы / ПМ / пользователя над иконками) — один ряд: название стола иконкой формы
// меню рабочей области, у базы / ПМ / пользователя — только иконки (названия — по Alt). Решение — по ширинам, измеренным
// ResizeObserver-ом шапки и ряда чипсов, а не по ширине окна. Выключатель fe.ux.topBarCompact (по умолчанию вкл).

export const TOPBAR_COMPACT_FLAG = 'fe.ux.topBarCompact'
// запас при возврате подписей: без него на границе полоса мигала бы между видами (подписи вернулись → чипсы снова в два ряда)
export const TOPBAR_COMPACT_HYSTERESIS = 24

// флаг из настроек базы (store.setting); мобильный профиль — свой вид шапки, сжатие не применяется
export function topbarCompact_on(store) {
    try {
        if (!store || typeof store.setting !== 'function') return false
        if (store.mobileUi && store.mobileUi.on) return false
        return store.setting(TOPBAR_COMPACT_FLAG, true) !== false
    } catch (e) { return false }
}

// ширина, которая нужна ряду чипсов в одну строку: элементы ряда (чипсы — своей шириной, растущее поле ввода — своим
// минимумом), промежутки gap между ними и внутренние отступы pad ряда
// items: [{ w, min, grow }] — w = offsetWidth, min = computed min-width, grow = элемент тянется (flex-grow > 0)
export function topbarCompact_need(items, gap = 0, pad = 0) {
    const list = (items || []).filter(it => it && !it.hidden)
    let sum = 0
    for (const it of list) {
        const w = +it.w || 0
        const min = +it.min || 0
        sum += it.grow ? min : Math.max(w, min)
    }
    return sum + Math.max(0, list.length - 1) * (+gap || 0) + (+pad || 0)
}

// следующее состояние сжатия:
//   on      — флаг включён;
//   compact — сейчас сжатая компоновка;
//   need    — ширина ряда чипсов в одну строку (topbarCompact_need);
//   avail   — ширина, которая у ряда чипсов есть сейчас;
//   saved   — сколько ширины вернут подписи и название стола при выходе из сжатия (полная ширина краёв − сжатая);
//   gap     — запас (TOPBAR_COMPACT_HYSTERESIS)
// В обычной компоновке сжимаемся, как только чипсам не хватает места в один ряд; из сжатой выходим, только если
// после возврата подписей чипсам хватит места с запасом. Не измерено (avail ≤ 0) — состояние не меняется.
export function topbarCompact_next({ on, compact, need, avail, saved, gap = TOPBAR_COMPACT_HYSTERESIS } = {}) {
    if (!on) return false
    if (!(avail > 0)) return !!compact
    if (!compact) return need > avail + 1
    return !(avail - need >= (+saved > 0 ? +saved : 0) + (+gap || 0))
}
